import { type RouteObject } from 'react-router'

import { RedirectToDashboardsV2 } from 'features/dashboard/Container'
import {
  DASHBOARD_DETAIL_TRANSACTION_PATH,
  DASHBOARD_EDIT_TRANSACTION_PATH,
  DASHBOARD_EDITOR_PATH_SEGMENT,
  DASHBOARD_LIST_TRANSACTION_PATH,
  DASHBOARD_URL,
  SHARE_CUSTOM_DASHBOARD,
} from 'features/dashboard/paths'

// Dashboards v1 is dead — every list/view/edit route just redirects to v2.
// See RedirectToDashboardsV2 for why the routes stay registered instead of
// 404ing.
export const dashboardRoutes: RouteObject[] = [
  {
    path: DASHBOARD_URL,
    element: <RedirectToDashboardsV2 />,
    handle: {
      sentryTransactionPath: DASHBOARD_LIST_TRANSACTION_PATH,
    },
  },
  {
    path: `${DASHBOARD_URL}/:customDashboardId`,
    element: <RedirectToDashboardsV2 />,
    handle: {
      sentryTransactionPath: DASHBOARD_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${DASHBOARD_URL}/:customDashboardId/${DASHBOARD_EDITOR_PATH_SEGMENT}`,
    element: <RedirectToDashboardsV2 />,
    handle: {
      sentryTransactionPath: DASHBOARD_EDIT_TRANSACTION_PATH,
    },
  },
]

export const sharedDashboardRoutes: RouteObject[] = [
  {
    // /project/:id/custom-dashboards/:dashboardId/shared/:token — redirect to
    // the v2 slug (/dashboards/:dashboardId/shared/:token) so old shared links
    // land on the v2 shared viewer.
    path: SHARE_CUSTOM_DASHBOARD,
    element: <RedirectToDashboardsV2 />,
  },
]
